import "./manageusers.css";
import DataTable from 'react-data-table-component';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HttpClient from '../utils/HttpClient';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import toast from "react-hot-toast";
const ManageFaq = () => {
    const [tableData, setTableData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1); // State for current page
    const [perPage, setPerPage] = useState(10); // State for number of entries per page
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();

    const columns = [
        {
            name: 'Question',
            selector: row => row.question,
            sortable: true,
            wrap: true
        },
        {
            name: 'Answer',
            selector: row => row.answer,
            sortable: true,
            wrap: true
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Action',
            selector: row => row.action,
            sortable: false,
            wrap: true,
        },
    ];

    const goToAddFAQ = () => {
        navigate('/managefaqform');
    };

    const getManageFaq = async () => {
        let newArr = [];
        const res = await HttpClient.requestData("faq", "GET");
        if (res && res?.status) {
            newArr = res?.data?.map((item, i) => ({
                i: i + 1,
                sl: i + 1,
                question: item?.question,
                answer: item?.answer,
                status: item?.status,
                action: (
                    <>
                        <span title="Edit" onClick={() => handleEdit(item)}>
                            <i className="fa-solid fa-pen-to-square"
                                style={{
                                    cursor: "pointer",
                                    marginRight: "5px",
                                    padding: "5px",
                                    fontSize: "1.5em",
                                    color: "#ff9c00",
                                    backgroundColor: "#fee5d2",
                                }}
                            ></i>
                        </span>
                        <span title="Delete" onClick={() => handleDelete(item?._id)}>
                            <i className="fa-solid fa-trash-can"
                                style={{
                                    cursor: "pointer",
                                    marginRight: "5px",
                                    padding: "5px",
                                    fontSize: "1.5em",
                                    color: "#C4554D",
                                    backgroundColor: "#FAECEC",
                                }}
                            ></i>
                        </span>
                        <span title={item.status === 'Active' ? 'Deactivate' : 'Activate'} onClick={() => handleStatus(item)}>
                            <i className={`fa-solid fa-${item.status === 'Active' ? 'minus-square' : 'plus-square'}`}
                                style={{
                                    cursor: "pointer",
                                    marginRight: "5px",
                                    padding: "5px",
                                    fontSize: "1.5em",
                                    color: item.status === 'Active' ? "#dc3545" : "#28a745",
                                    backgroundColor: item.status === 'Active' ? "#f8d7da" : "#d4edda",
                                }}
                            ></i>
                        </span>
                    </>
                )
            }));
            
            // Filter tableData based on searchQuery
            if (searchQuery.trim() !== '') {
                newArr = newArr.filter(item =>
                    item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    item.answer.toLowerCase().includes(searchQuery.toLowerCase())
                );
            }
            
            // Calculate start and end indexes based on currentPage and perPage
            const startIndex = (currentPage - 1) * perPage;
            const endIndex = startIndex + perPage;
            setTableData(newArr.slice(startIndex, endIndex));
        }
    };

    const handleEdit = (item) => {
        navigate('/managefaqform', { state: { item, isEdit: true } });
    };

    const handleDelete = async (id) => {
        const result = await MySwal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            confirmButtonColor: '#d33',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        });

        if (result.isConfirmed) {
            const res = await HttpClient.requestData(`faq/${id}`, "DELETE");
            if (res && res?.status) {
                MySwal.fire('Deleted!', 'FAQ has been deleted.', 'success');
                getManageFaq();
            } else {
                MySwal.fire('Error!', 'Failed to delete FAQ.', 'error');
            }
        }
    };

    const handleStatus = async (item) => {
        const newStatus = item.status === 'Active' ? 'Inactive' : 'Active';

        const res = await HttpClient.requestData(`faq-status/${item._id}`, "PUT", { status: newStatus });
        if (res && res?.status) {
            toast.success(`FAQ status changed to ${newStatus}.`);
            getManageFaq();
        } else {
            toast.error('Failed to update FAQ status.');
        }
    };

    useEffect(() => {
        getManageFaq();
    }, [searchQuery, perPage, currentPage]); // Include currentPage and perPage in dependencies

    return (
        <div className='manageUsers' style={{ position: 'relative' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 0' }}>
                <h3 style={{ fontSize: '20px' }}>Manage FAQ</h3>
                <h3 style={{ fontSize: '15px', color: 'rgb(208, 38, 38)', cursor: 'pointer' }} onClick={goToAddFAQ}>+ Add FAQ</h3>
            </div>
            <div className="userSelector" style={{ marginTop: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                        <label htmlFor="selectorInput"><b>Show</b></label>&ensp;
                        <select
                            id="selectorInput"
                            style={{ width: "65px" }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(parseInt(e.target.value));
                                setCurrentPage(1); // Reset currentPage when changing perPage
                            }}
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                        </select>&ensp;
                        entries
                    </div>
                    <div>
                        <label htmlFor="selectorInput"><b>Search: </b></label>&ensp;
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <DataTable
                className="dataTableContainer"
                columns={columns}
                data={tableData}
                pagination
                highlightOnHover
                striped
                noHeader={true}
                paginationPerPageOptions={[10, 20, 30, 40]} // Options for number of entries per page
                paginationRowsPerPageOptions={[10, 20, 30, 40]} // Options for number of entries per page in dropdown
                paginationPerPage={perPage} // Current number of entries per page
                paginationComponentOptions={{
                    rowsPerPageText: 'Entries per page:'
                }}
                paginationTotalRows={tableData.length} // Total number of rows in the table
                paginationOnChange={(page) => setCurrentPage(page)} // Event handler for change in current page
                customStyles={{
                    headCells: {
                        style: {
                            whiteSpace: 'normal', // Allow header text to wrap
                        },
                    },
                }}
            />
            <footer style={{ position: "fixed", bottom: "0", width: "fit-content", textAlign: "center", padding: "10px 0" }}>
                <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default ManageFaq;
